import React, {useContext} from 'react';
import QRCode from 'qrcode.react';
import {Context} from "../../MunicipalNoticeBoard";
import styled from 'styled-components';
import { shadowBorderString } from '../../mainCategory/StyledComponents';

export const QrCode = styled.div`
  background: ${(props) => props.theme.secondColor};
  border: ${(props) => `0.1rem solid ${props.theme.mainColor}`};
  ${(props) => shadowBorderString(props)}
`;

const DropDownCard = (props: { downloadItem: string; open: boolean }) => {

    const { menuPosition, highContrastMode, mainColor } = useContext(Context);

    return (
        <QrCode className={props.open ? 'open qr-code' : 'closed qr-code'} style={{
            top: menuPosition === "bottom" ? "26em" :  menuPosition === "top" ? "7em" : "24.5em",
            right: menuPosition === "center" ? "5.5em" : "3em",
        }}>
            <QRCode
                id="qr-code-download"
                value={props.downloadItem || ''}
                level="H"
                size={300}
                fgColor={highContrastMode ? "white" : mainColor}
                bgColor={highContrastMode ? "black" : "transparent"}
            />
        </QrCode>
    );
};

export default DropDownCard;
